import * as React from 'react';
import { Button, Responsive, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as styles from './EmptyPage.css';
import { NBSP } from '../../constants/symbols';

interface IEmptyPageProps {
  onFiltersButtonClick(): void;
}

export const EmptyPage: React.FC<IEmptyPageProps> = ({ onFiltersButtonClick }) => {
  return (
    <div className={styles['container']} data-name="EmptyPage">
      <div className={styles['image']} />
      <div className={styles['content']}>
        <div className={styles['title']}>
          <UIHeading2>В этом регионе у нас ещё нет строительных компаний</UIHeading2>
        </div>
        <UIText1 color="gray60_100">Попробуйте изменить что-нибудь в{NBSP}фильтрах </UIText1>
        <Responsive tablet phone>
          <div className={styles['filters-button']}>
            <Button theme="fill_primary" size="M" onClick={onFiltersButtonClick} fullWidth>
              Изменить фильтры
            </Button>
          </div>
        </Responsive>
      </div>
    </div>
  );
};
